<template>
  <q-dialog content-class="bg-black" v-model="showOverlay" transition-show="none" transition-hide="none" persistent
    no-shake>
    <div class="column items-center justify-center" v-if="showOverlay">
      <q-icon class="q-pb-lg" :name="errorMessages[lastErrorMessage].icon.name"
        :style="errorMessages[lastErrorMessage].icon.style ? errorMessages[lastErrorMessage].icon.style : ''"
        size="96px"></q-icon>
      <span class="q-pb-xs textBold">{{
          errorMessages[lastErrorMessage].textBold
      }}</span>
      <span class="text q-mb-md">{{ errorMessages[lastErrorMessage].text }}</span>
      <q-btn flat class="bg-grey-3" style="color: #373737" v-if="showBtn" @click="refreshPage">
        Refresh
      </q-btn>
    </div>
  </q-dialog>
</template>
<script>
import { LocalStorage, Platform } from 'quasar';
import { screenValidation } from 'src/libs/device';
export default {
  name: "Overlay",
  data() {
    return {
      showOverlay: false,
      lastErrorMessage: "",
    };
  },
  computed: {
    screenErrorType: {
      get() {
        return this.$store.state.app.screenErrorType;
      },
    },
    browserInvalid: {
      get() {
        return this.$store.state.app.browserInvalid;
      },
    },
    meetingStarted: {
      get() {
        if (Platform.is.desktop) {
          return LocalStorage.getItem("sid");
        }
        return this.$route.query.sid;
      },
    },
    errorMessages: {
      get() {
        return this.$store.state.app.errorMessages;
      }
    },
    showBtn: {
      get() {
        return (
          !this.screenErrorType && !this.browserInvalid && !this.meetingStarted
        );
      },
    },
  },
  watch: {
    screenErrorType() {
      if (!this.meetingStarted) {
        this.showOverlay = true;
      } else {
        this.showOverlay = !!this.screenErrorType;
      }
      this.setErrorText();
    },
    browserInvalid() {
      if (!this.meetingStarted) {
        this.showOverlay = true;
      } else {
        this.showOverlay = !!this.browserInvalid;
      }
      this.setErrorText();
    },
  },
  mounted() {
    if (!!this.screenErrorType || !!this.browserInvalid) {
      this.showOverlay = true;
    }
    this.setErrorText();
    window.addEventListener("resize", this.scrennResize(this.screenError));
  },
  methods: {
    setErrorText() {
      if (!!this.browserInvalid) {
        this.lastErrorMessage = "browser";
        return;
      }
      if (!!this.screenErrorType) {
        this.lastErrorMessage = this.screenErrorType ?? this.lastErrorMessage;
      }
    },
    refreshPage() {
      window.location.reload();
    },
    scrennResize(func) {
      let timer;
      return function (event) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(func, 100, event);
      };
    },
    async screenError() {
      if (this.browserInvalid) {
        return;
      }
      this.$store.commit("app/screenErrorType", screenValidation());
      await this.$meeting.sendCustomerErrors();
    },
  },
};
</script>
<style lang="scss" scoped>
.textBold {
  font-size: 14px;
  letter-spacing: 0.2px;
  font-weight: 600;
  line-height: 18px;
  text-align: center;
  max-width: 288px;
}

.text {
  font-size: 12px;
  letter-spacing: 0.2px;
  line-height: 16px;
  text-align: center;
  max-width: 288px;
}
</style>
